<template>
  <div id="app-loading" class="app-loading">
    <v-progress-circular indeterminate :size="50" color="secondary"></v-progress-circular>
    <span class="caption"></span>
  </div>
</template>

<script>
export default {
  data () {
    return {};
  },
  methods: {
    show (message = 'Cargando') {
      let loading = document.getElementById('app-loading');
      if (loading) {
        loading.style.display = 'flex';
        loading.querySelector('span').innerHTML = message;
      }
    },
    hide () {
      let loading = document.getElementById('app-loading');
      if (loading) {
        loading.style.display = 'none';
        loading.querySelector('span').innerHTML = '';
      }
    }
  }
};
</script>

<style lang="scss">
@import '../../../assets/scss/_variables.scss';
.app-loading {
  background-color: rgba(darken($primary, 42%), 0.8);
  display: none;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10000;
  justify-content: center;
  align-items: center;

  .v-progress-circular {
    margin: 0 10px 0 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/common/plugins/loading/AppLoading.vue